var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 21C11.7166 21 10.4916 20.7375 9.3249 20.2125C8.15824 19.6875 7.14157 18.95 6.2749 18L7.3499 16.925C8.0999 17.725 8.95824 18.3542 9.9249 18.8125C10.8916 19.2708 11.9166 19.5 12.9999 19.5C15.0832 19.5 16.8541 18.7667 18.3124 17.3C19.7707 15.8333 20.4999 14.0583 20.4999 11.975C20.4999 9.89167 19.7707 8.125 18.3124 6.675C16.8541 5.225 15.0832 4.5 12.9999 4.5C10.8666 4.5 9.08324 5.2375 7.6499 6.7125C6.21657 8.1875 5.4999 10.075 5.4999 12.375L7.6749 10.2L8.7499 11.275L4.7749 15.25L0.774902 11.25L1.8499 10.175L3.9999 12.325C3.9999 10.9917 4.23324 9.75417 4.6999 8.6125C5.16657 7.47083 5.80407 6.48333 6.6124 5.65C7.42074 4.81667 8.3749 4.16667 9.4749 3.7C10.5749 3.23333 11.7499 3 12.9999 3C14.2499 3 15.4207 3.2375 16.5124 3.7125C17.6041 4.1875 18.5541 4.82917 19.3624 5.6375C20.1707 6.44583 20.8124 7.39583 21.2874 8.4875C21.7624 9.57917 21.9999 10.75 21.9999 12C21.9999 13.25 21.7624 14.4208 21.2874 15.5125C20.8124 16.6042 20.1707 17.5542 19.3624 18.3625C18.5541 19.1708 17.6041 19.8125 16.5124 20.2875C15.4207 20.7625 14.2499 21 12.9999 21ZM16.0249 16.075L12.1749 12.275V6.925H13.6749V11.65L17.0999 15L16.0249 16.075Z",
    fill: "#498E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.e24dc2602150ace1427488a8b30a958e.svg";
export { ForwardRef as ReactComponent };